module.exports = __webpack_public_path__ + "static/media/calendar.452f8e88.svg";